import { useMemo } from "react";
import { useGetDataFromApi } from "../Func/GlobalFunction";
import parse from "html-react-parser";

function StarDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-3 ${className}`}>
      <span className="h-px w-16 bg-[#C9A227]/40" />
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        className="text-[#C9A227]"
        aria-hidden="true"
      >
        <path
          d="M12 1L14.5 8.5L22 6L16.5 12L22 18L14.5 15.5L12 23L9.5 15.5L2 18L7.5 12L2 6L9.5 8.5L12 1Z"
          fill="currentColor"
        />
      </svg>
      <span className="h-px w-16 bg-[#C9A227]/40" />
    </div>
  );
}

export const SejarahSection = () => {
  const { data } = useGetDataFromApi("contentsByCodename/sejarah");

  const filtered = useMemo(() => {
    if (!data) return [];
    const filtered = data.filter((item) => {
      const jenjang = item.rjenjang_id === 3;
      const lembaga = item.rlembaga_id === 0;
      const sekolah = item.rsekolah_id === 0;
      return jenjang && lembaga && sekolah;
    });
    return filtered;
  }, [data]);
  const sejarahData =
    filtered.length > 0
      ? filtered[0]
      : { judul: "Memuat...", deskripsi: "Memuat..." };
  return (
    <div className="min-h-screen bg-[#FAF6EE] text-[#2C2A25]">
      {/* HERO */}
      <section className="relative overflow-hidden border-b border-[#1F4D3D]/10 bg-gradient-to-b from-[#1F4D3D] to-[#173a2e] px-6 py-20 text-[#FAF6EE] sm:py-28">
        {/* pola geometris tipis di latar, khas seni ornamen pesantren */}
        <svg
          className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.07]"
          aria-hidden="true"
        >
          <pattern
            id="lattice"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(45)"
          >
            <path
              d="M20 0 L40 20 L20 40 L0 20 Z"
              fill="none"
              stroke="#C9A227"
              strokeWidth="1"
            />
          </pattern>
          <rect width="100%" height="100%" fill="url(#lattice)" />
        </svg>

        <div className="relative mx-auto max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#C9A227]">
            Sejarah Lembaga
          </p>
          <h1 className="mt-5 font-serif text-3xl font-semibold leading-tight tracking-tight sm:text-5xl">
            {sejarahData.judul}
          </h1>
          <StarDivider className="mt-8" />
        </div>
      </section>

      {/* KONTEN */}
      <section className="px-6 py-16 sm:py-24">
        <article className="mx-auto max-w-2xl">
          <div className="mb-8 flex items-center gap-3 text-sm text-[#1F4D3D]/70">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              aria-hidden="true"
            >
              <path d="M12 21s-7-6.1-7-11.5A7 7 0 0 1 19 9.5C19 14.9 12 21 12 21Z" />
              <circle cx="12" cy="9.5" r="2.3" />
            </svg>
            <span>Pesantren Idrisiyyah, Pagendingan, Tasikmalaya</span>
          </div>

          {/* Deskripsi */}
          <div className="prose-idrisiyyah font-serif text-[17px] leading-[1.9] text-[#2C2A25] sm:text-[19px]">
            {parse(sejarahData.deskripsi)}
          </div>

          <StarDivider className="mt-14" />
        </article>
      </section>

      <style>{`
        .prose-idrisiyyah p {
          margin-bottom: 1.5em;
        }
        .prose-idrisiyyah p:first-of-type::first-letter {
          float: left;
          font-size: 3.4em;
          line-height: 0.85;
          padding-right: 0.12em;
          padding-top: 0.06em;
          font-weight: 600;
          color: #1F4D3D;
        }
        .prose-idrisiyyah strong {
          color: #1F4D3D;
          font-weight: 700;
        }
      `}</style>
    </div>
  );
};
